<template>
  <div
    class="unpaid-invoice-banner relative flex h-9 w-full items-center justify-center bg-red-600 text-white"
  >
    <div class="flex items-center gap-1 text-sm">
      <span class="font-semibold">
        {{ $t('GENERAL.UNPAID_INVOICE_BANNER.MESSAGE') }}
      </span>

      <popover-select
        :options="invoices"
        :has-search="false"
        :disabled="isOnlyOneInvoice"
        @input="openSelectedInvoice"
      >
        <button @click="isOnlyOneInvoice ? openFirstInvoice() : null">
          {{ $t('GENERAL.UNPAID_INVOICE_BANNER.ACTION') }}
        </button>
      </popover-select>
    </div>

    <button
      class="absolute right-2.5 text-gray-300 transition-colors duration-300 hover:text-white"
      @click="handleBannerDismiss"
    >
      <fluent-icon icon="dismiss" size="16" />
    </button>
  </div>
</template>

<script>
// Libs //
import { mapGetters } from 'vuex';

// Components //
import PopoverSelect from '../../../shared/components/ui/PopoverSelect.vue';

export default {
  name: 'UnpaidInvoiceBanner',

  components: { PopoverSelect },

  computed: {
    ...mapGetters({
      paymentStatus: 'payments/getPaymentStatus',
    }),

    invoices() {
      return (this.paymentStatus?.openInvoices ?? []).map((invoice) => ({
        label: invoice.invoiceNumber ?? invoice.id,
        value: invoice.invoiceUrl,
      }));
    },

    isOnlyOneInvoice() {
      return this.invoices.length === 1;
    },
  },

  methods: {
    handleBannerDismiss() {
      this.$store.dispatch('payments/setIsUnpaidInvoiceBannerDismissed', true);
    },

    openFirstInvoice() {
      const firstInvoice = this.invoices[0];

      if (!firstInvoice) {
        return;
      }

      this.openSelectedInvoice(firstInvoice.value);
    },

    openSelectedInvoice(value) {
      if (!value) return;

      window.open(value, '_blank', 'noopener,noreferrer');
    },
  },
};
</script>

<style></style>
